import React from "react";
import { Grid, Typography } from "@material-ui/core";

const ContactDetails = () => {
  return (
    <Grid xs={12} sm={6} item style={{ marginBottom: 32 }}>
      <Typography style={{ fontWeight: 500, marginBottom: 16 }} variant="h3">
        Contact Us
      </Typography>
      <Typography style={{ fontWeight: 500, fontSize: "12pt" }}>
        Office:{" "}
        <span style={{ fontWeight: 400 }}>admin@lifehousechurch.org.za</span>
      </Typography>
      <Typography style={{ fontWeight: 500, fontSize: "12pt" }}>
        Tel: <span style={{ fontWeight: 400 }}>076 990 0359</span>
      </Typography>
      <Typography style={{ fontWeight: 500, fontSize: "12pt" }}>
        <a
          href="https://api.whatsapp.com/send/?phone=27769900359&text=Please+add+me+to+Lifehouse+Church+Broadcast+List&app_absent=0"
          target="_blank"
        >
          WhatsApp: <span style={{ fontWeight: 400 }}>076 990 0359</span>
        </a>
      </Typography>
      <Typography
        variant="h5"
        style={{ marginTop: 16, marginBottom: 8, fontWeight: 500 }}
      >
        Office Hours
      </Typography>
      <Typography style={{ fontWeight: 500, fontSize: "12pt" }}>
        Mon - Fri: <span style={{ fontWeight: 400 }}>08h00 - 12h00</span>
      </Typography>
    </Grid>
  );
};

export default ContactDetails;
